import { createClient, type SupabaseClient } from '@supabase/supabase-js'

import type { Database } from '../data'

let client: SupabaseClient<Database> | undefined

/**
 * The Supabase client, built on first use (and so only once the env is read).
 */
export const getSupabase = (): SupabaseClient<Database> => {
  if (client) return client

  const supabaseUrl: unknown = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey: unknown = import.meta.env.VITE_SUPABASE_ANON_KEY

  if (typeof supabaseUrl !== 'string' || !supabaseUrl) {
    throw new Error('Missing VITE_SUPABASE_URL environment variable')
  }

  if (typeof supabaseAnonKey !== 'string' || !supabaseAnonKey) {
    throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable')
  }

  client = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storageKey: 'supabase.auth.token',
    },
  })
  return client
}
